// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"3237":"e35662a62bd30bf6c629","3550":"ae66b666a63aa7708f02"}[chunkId] + ".js";
};